import { useState } from 'react';

export const useValidationError = () => {
    const [validationErrors, setValidationErrors] = useState([]);
    const [showErrorModal, setShowErrorModal] = useState(false);

    const showValidationErrors = (errors) => {
        setValidationErrors(errors || []);
        setShowErrorModal(true);
    };

    const hideValidationErrors = () => {
        setShowErrorModal(false);
        setValidationErrors([]);
    };

    const handleValidationError = (error) => {
        if (error.isValidationError && error.validationData) {
            showValidationErrors(error.validationData);
            return true; // Indicates validation error was handled
        }
        return false; // Not a validation error
    };

    return {
        validationErrors,
        showErrorModal,
        showValidationErrors,
        hideValidationErrors,
        handleValidationError
    };
};
